export const Notification = () => {
  return (
    <svg viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.6667 5.80085C12.6667 4.52759 12.175 3.30647 11.2998 2.40614C10.4247 1.5058 9.23768 1 8 1C6.76232 1 5.57534 1.5058 4.70017 2.40614C3.825 3.30647 3.33333 4.52759 3.33333 5.80085C3.33333 11.4018 1 13.0021 1 13.0021H15C15 13.0021 12.6667 11.4018 12.6667 5.80085Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.34541 16.2027C9.20867 16.4452 9.0124 16.6465 8.77625 16.7864C8.5401 16.9264 8.27237 17 7.99985 17C7.72733 17 7.4596 16.9264 7.22345 16.7864C6.98731 16.6465 6.79104 16.4452 6.6543 16.2027"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12.5" cy="4.5" r="2.5" fill="#CB0013" />
    </svg>
  )
}
